<div class="tw-flex tw-h-full">
    <div
        class="tw-mx-4 tw-mt-[80px] tw-mb-2 tw-flex-grow tw-items-center tw-overflow-hidden tw-bg-white">
        <app-selfservice-header></app-selfservice-header>
        <app-selfservice-language-selector></app-selfservice-language-selector>
        <router-outlet></router-outlet>
    </div>
</div>
